<div class="container container-style section-gap">
  <div class="d-flex justify-content-center align-items-center">
    <kla-title [lineConfig]="lineConfig" [config]="titleConfig" [showFooter]="false"></kla-title>
  </div>
  <div class="row">
    <div class="circle-charts-container">
      <div class="charts-container-line" *ngIf="showLineAcross"></div>
      <div class="charts-padding"
           *ngFor="let circleChart of config.circleCharts; even as isEven; let first = first; let last = last">
        <div class="charts-padding-after"
             *ngIf="showLineBetweenCircles"
             [class.first]="first"
             [class.last]="last"
             [style.background-color]='config.foregroundColor ||lineColor'>
        </div>
        <div class="circle-chart-title" [class.even]="isEven">
          <p class="first-line-texts">{{circleChart.title}} </p>
          <p class="second-line-texts">{{circleChart.subTitle}}</p>
        </div>
        <kla-simple-circle-chart
          [config]="generateConfig(circleChart.value, circleChart.circleText)"></kla-simple-circle-chart>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-10 offset-md-1 text-style">
      <app-dynamic-content
        [contentId]="'progressbar-circle-desc'"
        [htmlContent]="config.description">
      </app-dynamic-content>
    </div>
  </div>
  <div class="col-xs-10 offset-xs-1 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-6 offset-lg-3 progressbar">
    <kla-simple-progressbar [value]="config.progressChart?.value" [color]="config.foregroundColor"></kla-simple-progressbar>
    <p class="progress-to-text">{{config.progressChart?.title}}</p>
    <p class="center-text font-style">{{config.progressChart?.subTitle}}</p>
  </div>
</div>
